import React from 'react';
import PropTypes from 'prop-types';
import { Box, Stack, Typography } from '@mui/material';

// Metadatos de cada grupo de estado para los encabezados-divisores de las listas de sesiones.
// `path` apunta a theme.palette.sessionStatus[path].fg (color del punto).
export const STATUS_GROUP_META = {
  scheduled: { key: 'statusScheduledPlural', def: 'Programadas', path: 'scheduled' },
  pending: { key: 'statusPendingPlural', def: 'Pendientes por reportar', path: 'pending' },
  completed: { key: 'statusCompletedPlural', def: 'Completadas', path: 'completed' },
  absent: { key: 'absences', def: 'Ausencias', path: 'absent' }
};

// Orden de grupos (programadas → pendientes → completadas → ausencias).
export const STATUS_GROUP_ORDER = { scheduled: 0, pending: 1, completed: 2, absent: 3 };

// Encabezado-divisor: punto del color del estado + etiqueta + línea hairline.
function StatusGroupHeader({ label, color, first }) {
  return (
    <Stack direction="row" alignItems="center" spacing={1} sx={{ mt: first ? 0 : 2.5, mb: 0.5 }}>
      <Box sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: color, flexShrink: 0 }} />
      <Typography variant="caption" sx={{ fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.08em', color: 'text.secondary', whiteSpace: 'nowrap' }}>
        {label}
      </Typography>
      <Box sx={{ flex: 1, height: '1px', backgroundColor: 'hairline.main' }} />
    </Stack>
  );
}
StatusGroupHeader.propTypes = {
  label: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  first: PropTypes.bool.isRequired
};

export default StatusGroupHeader;
